import type { CompanyType } from "../schemas/CompaniesSchemas.ts";
import { Resources, type ResponseErrorType } from "../util/index.ts";
import type {
  ResourceAdapterType,
  ResourceAdapterToAdapterQueryKeysType,
} from "../util/index.ts";
import { restAPI } from "./api.ts";

export const CompanyAdapter: ResourceAdapterType<CompanyType> = {
  getList: () =>
    Promise.reject({
      success: false,
      error: "Method not implemented",
    } satisfies ResponseErrorType),
  /**
   * Get a single company
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/company/get_company
   */
  getOne: ({ id }) =>
    restAPI.nodeAPI
      .GET<CompanyType>({
        endpoint: `/companies/${id}`,
      })
      .then((resp) => ({ data: resp })),
  getMany: () =>
    Promise.reject({
      success: false,
      error: "Method not implemented",
    } satisfies ResponseErrorType),
  createOne: () =>
    Promise.reject({
      success: false,
      error: "Method not implemented",
    } satisfies ResponseErrorType),
  createMany: () =>
    Promise.reject({
      success: false,
      error: "Method not implemented",
    } satisfies ResponseErrorType),
  updateOne: () =>
    Promise.reject({
      success: false,
      error: "Method not implemented",
    } satisfies ResponseErrorType),
  updateMany: () =>
    Promise.reject({
      success: false,
      error: "Method not implemented",
    } satisfies ResponseErrorType),
  deleteOne: () =>
    Promise.reject({
      success: false,
      error: "Method not implemented",
    } satisfies ResponseErrorType),
  deleteMany: () =>
    Promise.reject({
      success: false,
      error: "Method not implemented",
    } satisfies ResponseErrorType),
};

export const CompanyAdapterQueryKeys: ResourceAdapterToAdapterQueryKeysType<
  ResourceAdapterType<CompanyType>
> = {
  getList: (params) => [Resources.COMPANY, "getList", params] as const,
  getOne: (params) => [Resources.COMPANY, "getOne", params.id] as const,
  getMany: () => [Resources.COMPANY] as const,
  createOne: () => [Resources.COMPANY] as const,
  createMany: () => [Resources.COMPANY] as const,
  updateOne: (_) => [Resources.COMPANY] as const,
  updateMany: (_) => [Resources.COMPANY] as const,
  deleteOne: () => [Resources.COMPANY] as const,
  deleteMany: () => [Resources.COMPANY] as const,
};
